<section class="server-error">
  @if (emailNotVerified()) {
    <h1 class="server-error__title">Check your email to finish signing in.</h1>
    <p class="server-error__text">
      We need to confirm your email address first. Open the verification link we sent you, then come back and sign in
      again.
    </p>
    <button type="button" class="btn btn-primary server-error__cta" (click)="signInAgain()">Sign in again</button>
    <p class="server-error__help">
      Can't find our email? Check your spam or junk folder, or write to
      <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a> and we'll get this sorted.
    </p>
  } @else {
    <h1 class="server-error__title">We've hit a snag.</h1>
    <p class="server-error__text">
      We're working on it. If you need help, email
      <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>.
    </p>
    <a class="server-error__link" routerLink="/">Go to the home page</a>
    @if (isDev && (auth.error$ | async); as err) {
      <pre class="server-error__debug">{{ err.message }}<br>{{ err | json }}</pre>
    }
  }
</section>
